import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import UserForm from "./Home/UserForm";
import Instructions from "./Home/Instructions";
import Exam from "./Exam/Exam";
import Thankyou from "./Exam/ThankYou";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<UserForm />} />
          <Route path="/instructions/:id" element={<Instructions />} />
          <Route path="/exam/:id" element={<Exam />} />
          <Route path="/thankyou" element={<Thankyou />} />
        </Routes>
      </Router>
      <ToastContainer position="top-center" draggable= {true} hideProgressBar={true} />
    </>
  );
}

export default App;
